import HttpClient from "@/common/boot/HttpClient"

const listarTiposTarefas = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/gestao-producao/tipos-tarefas', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  });

  commit('CARREGANDO', false);
}

const excluirTiposTarefas = async ({ dispatch },  payload) => { 
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
    dispatch('listarTiposTarefas');
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/gestao-producao/tipos-tarefas/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTipoTarefa = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/gestao-producao/tipos-tarefas', payload).then(response => {
    dispatch('listarTiposTarefas');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarTipoTarefa = ({ commit, state }, payload) => {

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_TIPO_TAREFA_SELECIONADA', ...item);
    return true;
  }

  return false;
}

const atualizarTipoTarefa = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/gestao-producao/tipos-tarefas/${payload.id}`, payload).then(response => {
    dispatch('listarTiposTarefas');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

export {
  listarTiposTarefas,
  excluirTiposTarefas,
  salvarTipoTarefa,
  recuperarTipoTarefa,
  atualizarTipoTarefa
}